/**
 * Preloader timings (Design System v3.3, "Preloader"). Milliseconds.
 * Shared by Preloader.vue and anything that wants to reason about it.
 */
export const PRELOADER_MS = Object.freeze({
    /** Ready within this long after it was asked for: never shown at all. */
    skip: 120,
    fadeIn: 80,
    /** Tile scales in, the three pieces fly in and lock. */
    build: 460,
    tile: 180,
    piece: 290,
    /** Ready early: the rest of the build is sped up to finish within this. */
    rush: 140,
    fadeOut: 120,
    /** A+ only: the white veil's slow fill on a long wait, its completion, the hold. */
    veil: 2600,
    veilComplete: 160,
    hold: 100,
    /** Reduced motion: a plain fade of the tile, nothing moves. */
    reducedFade: 120,
});

export type PreloaderMs = typeof PRELOADER_MS;

/** First path segment, the "module": /estimates/12/plans -> 'estimates'. */
export function moduleOfPath(path: string | null | undefined): string {
    return String(path || '').split('?')[0].split('#')[0].split('/').filter(Boolean)[0] || '';
}
